import * as z from "zod/v4";
export const ConnectionStatusSchema = z.enum([
    "CONNECTED",
    "DISCONNECTED",
    "ERROR",
]);
//# sourceMappingURL=connection-status.js.map